<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">할인차량관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">할인차량 관리</p>
          <ul class="depth">
            <li><router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link></li>
            <li><router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">할인차량 관리</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ totalCnt }}</span
              >건
            </div>
            <div class="searchBox">
              <div>
                <select id="" title="검색영역 선택" v-model="searchCondition">
                  <option value="1">사용자명</option>
                  <option value="2">차량번호</option>
                  <option value="">사용자명+차량번호</option>
                </select>
                <input
                  type="text"
                  title="검색어 입력"
                  v-model="searchKeyword"
                  placeholder="검색어입력"
                  @keydown.enter="findDiscountCar"
                />
              </div>
              <button type="button" class="btn dkGray" @click="findDiscountCar">검색</button>
            </div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  할인차량 관리 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">번호</th>
                    <th scope="col">사용자명</th>
                    <th scope="col">차량번호</th>
                    <th scope="col">할인유형</th>
                    <th scope="col">할인기간</th>
                    <th scope="col">비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="8">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in calData" :key="index" @click="view(item.seqId)">
                    <td>{{ ( listData.length - index ) - ( (curPageNum-1) * dataPerPage ) }}</td>
                    <td>{{ item.carOwnerNm }}</td>
                    <td>{{ item.carNo }}</td>
                    <td>{{ item.discountNm }}</td>
                    <td>{{ item.startDt }} - {{ item.endDt }}</td>
                    <td>{{ item.note }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--btnArea-->
          <div class="btnArea txt-right">
            <button type="button" class="btn border" @click="$router.push('discountvehicleenrollment')">등록</button>
          </div>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
      totalCnt: 0,
      searchCondition: 1,
      searchKeyword: '',
      nodata: true,
    };
  },

  mounted() {
    this.findDiscountCar();
  },

  methods: {
    async findDiscountCar() {
      const res = await axios('get', '/api/admin/discount/list.json', {
        searchCondition: this.searchCondition,
        searchKeyword: this.searchCondition == 2 ? this.searchKeyword.replace(/\s/gi, '') : this.searchKeyword,
        pageIndex: this.curPageNum,
        pageUnit: 10000,
      });
      const data = res.data.resultList.result.list;
      if (!data || data.length <= 0) {
        this.listData = [];
        this.nodata = true;
        this.totalCnt = 0;
        return;
      }
      this.totalCnt = data.length;
      this.listData = data;
      this.nodata = false;
      this.curPageNum = 1;
    },

    view(seqId) {
      this.$router.push({
        path: 'discountvehicleview',
        query: { seqId: seqId },
      });
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length < 0) {
        return;
      }
        return this.listData.slice(this.startOffset, this.endOffset);
    },
  },
};
</script>
